import { cn } from "@/lib/utils";

import type { YearSection } from "../lib/grouping";

export function WhatsNewTimeline({
  sections,
  activeMonthKey,
  onMonthClick,
}: {
  sections: YearSection[];
  activeMonthKey: string | null;
  onMonthClick: (key: string) => void;
}) {
  if (sections.length === 0) return null;

  return (
    <nav className="hidden w-44 shrink-0 overflow-y-auto border-r border-border bg-card/40 px-3 py-4 text-xs md:block">
      {sections.map((year) => (
        <div key={year.year} className="mb-4 last:mb-0">
          <div className="mb-1.5 flex items-center gap-2 font-semibold text-foreground">
            <Dot filled className="bg-brand" />
            {year.year}
            {year.unreadCount > 0 && (
              <span className="rounded-full bg-brand/15 px-1.5 text-[10px] font-semibold text-brand">
                {year.unreadCount}
              </span>
            )}
          </div>
          <ul className="ml-3 flex flex-col gap-1 border-l border-border pl-3">
            {year.months.map((month) => {
              const active = month.key === activeMonthKey;
              return (
                <li key={month.key}>
                  <button
                    type="button"
                    onClick={() => onMonthClick(month.key)}
                    className={cn(
                      "flex w-full items-center gap-2 rounded px-1.5 py-1 text-left transition-colors",
                      active
                        ? "bg-brand/10 text-brand"
                        : "text-foreground/70 hover:bg-accent hover:text-foreground",
                    )}
                  >
                    <Dot
                      filled={active}
                      className={active ? "bg-brand" : "border-brand"}
                    />
                    <span className="flex-1">{month.monthLabel}</span>
                    <span className="text-[10px] text-muted-foreground">
                      {month.dateGroups.reduce((n, g) => n + g.entries.length, 0)}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}

function Dot({ filled, className }: { filled: boolean; className?: string }) {
  return (
    <span
      className={cn(
        "inline-block h-2 w-2 shrink-0 rounded-full border",
        filled ? "border-transparent" : "bg-transparent",
        className,
      )}
    />
  );
}
